import { useMemo } from 'react'

import { Voice } from '@/core/api/entities/campaign/voice'
import { useTranslation } from '@/core/i18n/useTranslation'

// Collection translation keys (collectionId -> i18n key)
const COLLECTION_I18N_KEYS: Record<string, string> = {
	UsvZmwEZGwelIgXXzpxc: 'ai.voice_collections.chile',
	Tuv9ByQoeJfSfvEQvG8p: 'ai.voice_collections.costa_rica',
	FWyjZiITIOJymLl5XpGm: 'ai.voice_collections.ecuador',
	Ebz9ij1L6DH5BMHYxxhA: 'ai.voice_collections.peru',
	oc0JT4rD3owwKeaWqxgv: 'ai.voice_collections.venezuela',

	N8QYgNJpQfIsPvf26oLR: 'ai.voice_collections.hindi',
	CQ1Bqs9gMz2dKrdEUuMS: 'ai.voice_collections.macedonia',
	G6SjbwN82qtxuTKBp1pb: 'ai.voice_collections.malaysia',
	eJkQ7GV1TznHvYW916l6: 'ai.voice_collections.brazil',
	ySOoZVhjCuUdP4NnzK5j: 'ai.voice_collections.italy',
	j3s3u1rYfw4qNtZRPf3M: 'ai.voice_collections.greece',
	IXTuWSSTtFLS1zkIVY2X: 'ai.voice_collections.united_states',
	'7NXNYhBelEyQoUEjSAkF': 'ai.voice_collections.england',
	FetVZg3r2CfBToYVeNHn: 'ai.voice_collections.spain',
	kJp1TEQ6PzYn6nWmr5Sj: 'ai.voice_collections.argentina',
	iKUIlR4V7Do3JiLB3udA: 'ai.voice_collections.colombia',
	'44DJK6FFBWobumWI0FR9': 'ai.voice_collections.mexico_y_neutral',
	Zs5jV6yLOmuZlKourLnS: 'ai.voice_collections.uruguay',
	EEPMGejdFi9LHM02sp4R: 'ai.voice_collections.russia',
}

export const useVoicesCatalog = (voices: Voice[] | undefined | null) => {
	const { t } = useTranslation('campaigns')

	const voicesByCollection = useMemo(() => {
		if (!voices) return {}
		return voices.reduce(
			(acc, voice) => {
				const collections = voice.collectionIds || []
				collections.forEach((collectionId) => {
					if (!acc[collectionId]) acc[collectionId] = []
					acc[collectionId].push(voice)
				})
				return acc
			},
			{} as Record<string, Voice[]>
		)
	}, [voices])

	const collectionOptions = useMemo(() => {
		return Object.keys(voicesByCollection)
			.map((id) => {
				const key = COLLECTION_I18N_KEYS[id]
				if (!key) {
					return { value: id, label: id }
				}

				const translated = t(key)
				return {
					value: id,
					label: translated === key ? id : translated,
				}
			})
			.sort((a, b) => a.label.localeCompare(b.label))
	}, [voicesByCollection, t])

	return {
		voicesByCollection,
		collectionOptions,
		COLLECTION_I18N_KEYS,
	}
}
